(() => {
  'use strict';
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];
  const config = JSON.parse($('#cc-store-config')?.textContent || '{}');
  const rootUrl = (config.root || '/').replace(/\/?$/, '/');
  const money = value => new Intl.NumberFormat(({ES:'es-ES',MX:'es-MX',CO:'es-CO',AR:'es-AR',CL:'es-CL'})[config.country] || 'es-MX', {style: 'currency', currency: config.currency || 'MXN'}).format(value / 100);
  let accordionId = 0;

  function init(scope = document) {
    $$('.gp-accordion-item_header', scope).forEach(header => {
      if (header.dataset.ccReady) return;
      const item = header.closest('.gp-accordion-item');
      if (!item) return;
      const body = $('.gp-accordion-item_body', item);
      if (!body) return;
      header.dataset.ccReady = 'true';
      if (!header.id) header.id = `cc-faq-${++accordionId}`;
      body.id = `${header.id}-content`;
      header.setAttribute('aria-controls', body.id);
      body.setAttribute('role', 'region');
      body.setAttribute('aria-labelledby', header.id);
      const setOpen = open => {
        header.setAttribute('aria-expanded', String(open));
        body.dataset.show = String(open);
        body.setAttribute('aria-hidden', String(!open));
        body.inert = !open;
        // The captured markup has an inline 0fr value, which overrides CSS selectors.
        body.style.gridTemplateRows = open ? '1fr' : '0fr';
      };
      setOpen(header.getAttribute('aria-expanded') === 'true');
      const toggle = () => setOpen(header.getAttribute('aria-expanded') !== 'true');
      header.addEventListener('click', toggle);
      header.addEventListener('keydown', e => {if (e.key === 'Enter' || e.key === ' ') {e.preventDefault();toggle();}});
    });
    $$('[data-cc-carousel]', scope).forEach(carousel => {
      if (carousel.dataset.ccReady) return;
      carousel.dataset.ccReady = 'true';
      const track = $('.gem-slider', carousel);
      if (!track) return;
      const slides = [...track.children].filter(x => x.classList.contains('gem-slider-item'));
      if (!slides.length) return;
      const type = carousel.getAttribute('type');
      let index = 0;
      function go(i) {
        i = Math.max(0, Math.min(slides.length - 1, i));
        track.scrollTo({left: slides[i].offsetLeft - slides[0].offsetLeft, behavior: 'smooth'});
      }
      $('.gem-slider-previous', carousel)?.addEventListener('click', () => go(index - 1));
      $('.gem-slider-next', carousel)?.addEventListener('click', () => go(index + 1));
      if (type === 'grid-carousel') {
        const gallery = carousel.closest('gp-product-images');
        const featured = $('[type="gp-feature-image-carousel"] .gem-slider', gallery);
        slides.forEach((slide, i) => {
          slide.setAttribute('role', 'button');slide.tabIndex = 0;
          slide.setAttribute('aria-label', `Ver imagen ${i + 1}`);
          const select = () => featured?.scrollTo({left: featured.clientWidth * i, behavior: 'smooth'});
          slide.addEventListener('click', select);
          slide.addEventListener('keydown', e => {if (e.key === 'Enter' || e.key === ' ') {e.preventDefault();select();}});
        });
        slides[0]?.classList.add('cc-thumb-active');
      }
      let dots = [];
      if (!type) {
        $$('.gp-carousel-dots, .gem-slider-pagination', carousel).forEach(x => x.remove());
        const dotBar = document.createElement('div');
        dotBar.className = 'cc-carousel-dots';
        slides.forEach((slide, i) => {
          const dot = document.createElement('button');dot.type = 'button';
          dot.setAttribute('aria-label', `Ver reseña ${i + 1}`);dot.setAttribute('aria-current', String(i === 0));
          dot.addEventListener('click', () => go(i));dotBar.append(dot);dots.push(dot);
        });
        $('.gp-carousel-wrapper', carousel)?.append(dotBar);
      }
      track.addEventListener('scroll', () => {
        const width = slides[0].getBoundingClientRect().width + (parseFloat(getComputedStyle(track).columnGap) || 0);
        index = Math.round(track.scrollLeft / Math.max(1, width));
        dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === index)));
        if (type === 'gp-feature-image-carousel') {
          const gallery = carousel.closest('gp-product-images');
          $$('[type="grid-carousel"] .gem-slider-item', gallery).forEach((s, i) => {
            s.classList.toggle('cc-thumb-active', i === index);
            s.setAttribute('aria-pressed', String(i === index));
          });
        }
      }, {passive: true});
      // Native touch scrolling plus mouse drag, without capturing clicks on nested links.
      let drag;
      track.addEventListener('pointerdown', e => {
        if (e.pointerType !== 'mouse' || e.button !== 0 || e.target.closest('a,button,input,select')) return;
        drag = {x:e.clientX,left:track.scrollLeft};
      });
      track.addEventListener('pointermove', e => {if (drag) {track.scrollLeft = drag.left + drag.x - e.clientX;}});
      window.addEventListener('pointerup', () => {drag = null;});
      track.addEventListener('dragstart', e => e.preventDefault());
    });
    $$('[data-cc-product-form]', scope).forEach(form => {
      if (form.dataset.ccReady) return;
      form.dataset.ccReady = 'true';
      const previewOffer = radio => {
        if (!radio || radio.dataset.discountMode === 'catalog') return;
        const label = radio.closest('[data-cc-offer]');
        const subtotal = Number(radio.dataset.unitPrice) * Number(radio.dataset.quantity || 1);
        const value = Number(radio.dataset.discountValue || 0);
        if (!Number.isFinite(subtotal) || (!value && radio.dataset.discountType !== 'bogo_extra')) return;
        let discount;
        if (radio.dataset.discountType === 'bogo_extra') {
          discount = subtotal - Math.round(subtotal * Math.max(0,100-value) / 200);
        } else if (radio.dataset.discountType === 'amount') {
          const rate = config.currency === radio.dataset.baseCurrency ? 1 : Number(window.Shopify?.currency?.rate);
          const conversion = rate > 0 ? rate : Number(radio.dataset.unitPrice) / Number(radio.dataset.baseUnitPrice);
          discount = Math.round(value * 100 * conversion);
        } else discount = Math.round(subtotal * value / 100);
        const price = $('.cc-offer-price strong',label), compare = $('.cc-offer-price s',label);
        if (price) price.textContent = money(Math.max(0,subtotal-discount));
        if (compare) {compare.textContent = money(subtotal);compare.hidden = discount <= 0;}
      };
      $$('input[name="cc_pack"]',form).forEach(previewOffer);
      const select = () => {
        const choices = $$('input[name="cc_pack"]', form);
        let picked = choices.find(x => x.checked && !x.disabled);
        if (!picked && choices.length) {picked = choices.find(x => !x.disabled); if (picked) picked.checked = true;}
        $$('[data-cc-offer]', form).forEach(label => label.classList.toggle('is-selected', Boolean($('input:checked', label))));
        const input = $('input[name="id"]', form);
        const single = $('[data-cc-single-variant]', form);
        if (input && (picked || single)) input.value = picked?.value || single.value;
        const atc = $('[data-cc-atc]', form);
        if (atc) {
          atc.disabled = !input?.value || (choices.length > 0 && !picked) || (!choices.length && form.dataset.ccAvailable === 'false');
          atc.setAttribute('aria-disabled', String(atc.disabled));
        }
      };
      form.addEventListener('change', e => {
        if (e.target.matches('[data-cc-variant-select]')) {
          const label = e.target.closest('[data-cc-offer]');
          const radio = $('input[type="radio"]', label);radio.value = e.target.value;radio.checked = true;
          const option = e.target.selectedOptions[0];
          radio.dataset.unitPrice = option.dataset.unitPrice;
          const price = $('.cc-offer-price strong', label);if (price) price.textContent = option.dataset.price;
          const old = $('.cc-offer-price s', label);if (old) {old.textContent = option.dataset.compare;old.hidden = !option.dataset.compare;}
          previewOffer(radio);
        }
        select();
      });
      select();
      form.addEventListener('submit', async e => {
        e.preventDefault();
        if (form.dataset.ccBusy === 'true') return;
        select();
        const id = $('input[name="id"]', form)?.value;
        const atc = $('[data-cc-atc]', form);
        if (!id || atc?.disabled) return;
        form.dataset.ccBusy = 'true';
        if (atc) {atc.dataset.state = 'loading';atc.disabled = true;}
        const error = $('[data-cc-purchase-error]');if (error) error.hidden = true;
        try {
          const offer = $('input[name="cc_pack"]:checked', form);
          const automatic = (offer?.dataset.discountMode || 'automatic') === 'automatic';
          const quantity = Number(offer?.dataset.quantity || 1);
          const units = Number(offer?.dataset.units || 1);
          const code = offer?.dataset.discountMode === 'code' ? offer.dataset.code || '' : '';
          const variantId = automatic && offer && !offer.dataset.discountMode ? $('input[name="cc_pack"]',form).value : id;
          await window.CicatricreamCart.add({id:variantId, quantity: automatic ? quantity * units : quantity, properties: {
            _cc_units: automatic ? '1' : String(units),
            _cc_offer: offer?.dataset.label || '',
            _cc_offer_code: code,
            _cc_auto_offer: String(automatic)
          }}, code);
        } catch (err) {
          if (error) {error.textContent = err.message;error.hidden = false;error.scrollIntoView({block:'center',behavior:'smooth'});}
        } finally {
          form.dataset.ccBusy = 'false';if (atc) atc.dataset.state = 'idle';select();
        }
      });
    });
    $$('[data-cc-buy-scroll]', scope).forEach(b => {
      if (b.dataset.ccReady) return;b.dataset.ccReady = 'true';
      b.addEventListener('click', () => ($('.cc-offers') || $('[data-cc-atc]') || $('#MainContent'))?.scrollIntoView({behavior:'smooth',block:'center'}));
    });
  }

  function countdown() {
    const now = new Date();
    const target = new Date(Date.UTC(now.getUTCFullYear(),now.getUTCMonth(),now.getUTCDate(),14,30));
    if (target <= now) target.setUTCDate(target.getUTCDate()+1);
    const secs = Math.max(0,Math.floor((target-now)/1000));
    const values = {day:Math.floor(secs/86400),hour:Math.floor(secs/3600)%24,minute:Math.floor(secs/60)%60,second:secs%60};
    $$('gp-countdown-timer').forEach(timer => Object.entries(values).forEach(([id,v]) => {const n = $(`[id="${id}"] .gp-countdown-number`,timer);if (n) n.textContent = String(v).padStart(2,'0');}));
  }
  init();countdown();if ($('gp-countdown-timer')) setInterval(countdown,1000);
  document.addEventListener('shopify:section:load',e => init(e.target));
})();
